export const defaultUser = {
    username: 'Andrew',
    email: 'admin@gmail.com',
    password: '1234'
}

export const eyes = ['OS', 'OD'];

export const userTypeOptions = [
    { label: 'Seller', value: 'seller' },
    { label: 'Customer', value: 'customer' }
]

export const BooleanValueTypes = [
    { label: 'Yes', value: true },
    { label: 'No', value: false }
]